import BusinessListVerticalTab from "../../../components/business/business/businessListVerticalTab";
import Portal from "../portal";

const BusinessPortal = (match) => {
  return <Portal TabComponent={BusinessListVerticalTab} />;
};
export default BusinessPortal;
